export default __webpack_public_path__ + "static/media/Upload_2.5fce423b.png";